<!-- 嵌入式-报警管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button
        type="primary"
        @click="onCloseItems"
        v-permission="'dci_trigger_alarm-POST'"
      >
        <i class="fa fa-times"></i> 批量关闭
      </el-button>
      <div class="former">
        <el-input
          v-model.trim="former.key"
          placeholder="点位名称/报警内容/触发器名称"
          @keydown.enter.native="onSubmitQuery"
          style="width: 300px"
        >
        </el-input
        >&nbsp;
        <el-select
          v-model="former.dciProductModelName"
          clearable
          placeholder="选择产品型号"
          style="width: 250px"
          v-if="!proDisabled"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele"
            :label="ele"
            :value="ele"
          >
          </el-option> </el-select
        >&nbsp;
        <!-- <select2
          labelName="NameNumber"
          v-model="former.dciproductmodelid"
          url="dci/model/product/list?order=name"
          clearable
          placeholder="选择产品型号"
          no-data-text="没有产品型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
          v-if="!proDisabled"
        ></select2
        >&nbsp; -->
        <select2
          labelName="SN"
          v-model="former.dciproductid"
          :url="productUrl"
          placeholder="请选择产品SN"
          no-data-text="无产品"
          :urlParams="urlParams"
          q="SN:like"
          :qinwhere="true"
          :queryOne="false"
          :disabled="proDisabled"
          :currentList="currentProduct"
        ></select2
        >&nbsp;
        <el-select v-model="former.Status" clearable placeholder="状态">
          <el-option label="未关闭" :value="0"></el-option>
          <el-option label="已关闭" :value="1"></el-option> </el-select
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>

    <div id="app">
      <el-table
        :data="alarmList"
        v-loading="loading"
        ref="tableItems"
        @selection-change="onSelectChanged"
        :row-key="getRowKey"
      >
        <el-table-column
          type="selection"
          width="45"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          type="index"
          :index="pager.size * (pager.page - 1) + 1"
          :width="
            Math.max(40, (pager.size * pager.page).toString().length * 12)
          "
        />
        <el-table-column
          prop="DciStation.DciProduct.DciProductModel.NameNumber"
          label="产品型号名称"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="DciStation.DciProduct.SN"
          label="产品SN"
          width="160"
          ><template slot-scope="scope">
            <el-tag>
              {{ scope.row.DciStation.DciProduct.SN }}
            </el-tag>
          </template></el-table-column
        >
        <el-table-column
          prop="DciStation.Name"
          label="点位名称"
        ></el-table-column>
        <el-table-column
          prop="Message"
          label="报警内容"
          width="100"
        ></el-table-column>
        <el-table-column prop="Payload" label="具体内容" show-overflow-tooltip
          ><template scope="scope">
            <span>{{ scope.row.Payload }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DciTrigger.Name" label="触发器名称" width="120">
          <!-- <template scope="scope">
          <span>{{
            scope.row.DciTrigger ? scope.row.DciTrigger.Name : ""
          }}</span>
        </template> -->
        </el-table-column>
        <el-table-column prop="CreatedAt" label="报警时间" width="160">
          <template scope="scope">
            <span>{{
              $sys.dateFormat(scope.row.CreatedAt, "Y-m-d H:i:s")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Status === 0" type="warning">
              未关闭
            </el-tag>
            <el-tag v-else> 已关闭 </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template scope="scope">
            <el-button
              type="primary"
              title="关闭"
              @click="onCloseAlarm(scope.row)"
              :disabled="scope.row.Status === 1"
              v-permission="'dci_trigger_alarm-POST'"
            >
              <i class="fas fa-stop-circle"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      alarmList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        Status: "",
        key: "",
        dciproductid: "",
        // dciproductmodelid: "",
        dciProductModelName: "",
      },
      itemList: {
        ids: [],
      },
      productUrl: "dci/product/stock-list/list?order=-sn",
      urlParams: { where: {} },
      currentProduct: [],
      proDisabled: false,
      modelList: [], //产品型号
    };
  },
  mounted() {
    //产品点位数据查询报警信息
    if (this.$route.query.sn) {
      this.former.dciproductid = this.$route.query.id;
      this.currentProduct = [
        {
          ID: this.$route.query.id,
          SN: this.$route.query.sn,
        },
      ];
      this.proDisabled = true;
    }

    this.getModelList();
    this.getAlarmList();
  },
  watch: {
    "former.dciProductModelName": {
      handler() {
        this.productUrl = `dci/product/stock-list/list?order=-sn`;
        this.urlParams = {
          where: {},
          dciProductModelName: this.former.dciProductModelName,
        };
      },
    },
  },
  methods: {
    getAlarmList() {
      this.loading = true;
      this.$axios
        .get(`dci/triggeralarm`, {
          params: {
            where: {
              Status: this.former.Status,
            },
            key: this.former.key,
            dciproductid: this.former.dciproductid,
            // dciproductmodelid: this.former.dciproductmodelid,
            dciProductModelName: this.former.dciProductModelName,
            ...this.pager,
            with: ["DciStation.DciProduct.DciProductModel", "DciTrigger"],
            order: ["-created_at"],
          },
        })
        .then(
          (response) => {
            this.alarmList = response.data.data;
            this.pager = _.pick(response.data, "size", "page", "total");
          },
          (response) => {
            this.$sys.alarmResponse(response);
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;
          // this.modelList.push({
          //   ID: 0,
          //   NameNumber: "其它类型",
          // });
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 搜索查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getAlarmList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getAlarmList();
    },
    // 关闭通知警报
    onCloseAlarm(row) {
      this.itemList.ids = [];
      this.itemList.ids.push(row.ID);

      this.onCloseItems();
    },

    //批量关闭通知警报
    onCloseItems() {
      this.$confirm("确定要关闭报警信息吗？", "提示")
        .then(() =>
          this.$axios.request({
            url: "dci/triggeralarm/close",
            method: "post",
            data: this.itemList,
          })
        )
        .then(() => {
          this.getAlarmList();
          this.$message.success("关闭成功");

          this.itemList.ids = [];
          this.$refs.tableItems.clearSelection();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    //选择报警
    onSelectChanged(options) {
      this.itemList.ids = options.map((x) => x.ID);
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>
<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 0 10 0;
      font-size: larger;
    }
  }
}
</style>